<template>
  <div
    v-if="$route.path === '/user/feed'">
    <v-btn
      v-if="privileges.chat.private_chat"
      class="chatbutton primary"
      @click.prevent="openChat"
      fixed
      dark
      bottom
      right
      fab>
      <v-icon class="chaticon">chat</v-icon>
      <span v-if="unread" class="unread">{{unread}}</span>
    </v-btn>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      unread: 0,
      contacts: []
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUserDetails
    },
    privileges () {
      return this.$store.getters.getUserPrivileges
    }
  },
  methods: {
    openChat () {
      window.$applozic('#mck-sidebox').mckModal('show')
      window.$applozic.fn.applozic('loadTab', '')
      window.$('html').addClass('sidebox-open')
      this.setDefaultContacts()
    },
    async setDefaultContacts () {
      const self = this
      const contactSnap = await this.$firebase.database().ref('default_chat_contact').once('value')
      const contacts = contactSnap.val() || []
      const users = this.$store.getters.fetchUsers
      let parentNode = document.getElementById('mck-contact-list')
      const noConversationNode = document.getElementById('mck-no-conversations')
      const mckInner = document.querySelector('#mck-message-cell .mck-message-inner')
      const nodes = contacts.reduce((d, contact) => {
        const user = users.find(user => user.uid === contact.uid)
        // check if already exist
        if (user) {
          const contactExist = document.getElementById(`li-user-${user.uid}`)
          if (contactExist) return d + ''
          var node = self.getNode(user)
          return d + node
        }
        return d
      }, '')
      const fragment = document.createRange().createContextualFragment(nodes)
      if (!parentNode) {
        mckInner.innerHTML = '<ul id="mck-contact-list" class="mck-contact-list mck-nav mck-nav-tabs mck-nav-stacked">'
        parentNode = document.getElementById('mck-contact-list')
      }
      if (noConversationNode) {
        setTimeout(() => {
          noConversationNode.classList.remove('vis')
          noConversationNode.classList.add('n-vis')
        }, 800)
      }
      parentNode.prepend(fragment)
    },
    getNode (user) {
      const avatar = user.avatar.indexOf('http') >= 0 ? user.avatar : `${window.location.protocol}//${window.location.host}${user.avatar}`
      const fullName = `${user.firstname} ${user.lastname}`
      return `
      <li id="li-user-${user.uid}" class="li-user-${user.uid} ${user.uid}"
        data-msg-time="1539049156786"><a class="applozic-launcher" href="#" target="_self" data-mck-conversationid=""
          data-mck-id="${user.uid}" data-mck-clientgroupid="" data-isgroup="false">
          <div class="mck-row" title="${fullName}">
            <div class="mck-conversation-topic mck-truncate n-vis"></div>
            <div class="blk-lg-3"><img src="${avatar}"></div>
            <div class="blk-lg-9">
              <div class="mck-row">
                <div class="blk-lg-8 mck-cont-name mck-truncate">
                  <div class="mck-ol-status n-vis"><span class="mck-ol-icon" title="Online"></span>&nbsp;</div><strong>${fullName}</strong>
                </div>
                <div class="mck-text-muted move-right mck-cont-msg-date mck-truncate blk-lg-4"></div>
              </div>
              <div class="mck-row">
                <div class="mck-cont-msg-wrapper blk-lg-6 mck-truncate msgTextExpr">
                  <p>Hello, how can I help you?</p>
                </div>
                <div class="mck-unread-count-box move-right mck-truncate n-vis"><span class="mck-unread-count-text">0</span></div>
              </div>
            </div>
          </div>
        </a>
      </li>
    `
    }
  },
  beforeDestroy () {
    const chatTotalUnreadCountId = Number(localStorage.getItem('chatTotalUnreadCountId'))
    window.clearInterval(chatTotalUnreadCountId)
    localStorage.removeItem('chatTotalUnreadCountId')
  },
  mounted () {
    const self = this
    const path = this.$route.path
    this.$store.dispatch('loadUsers')
    if (!['/user/feed', '/contractors'].includes(path)) return
    window.$applozic && window.$applozic.fn.applozic({
      appId: 'tsvcommunityxchange3b1149dc15a',
      userId: this.user.uid,
      userName: `${this.user.firstname}-${this.user.lastname}`,
      imageLink: this.user.avatar,
      email: this.user.email,
      labels: { 'last.seen.on': 'Last seen' },
      contactNumber: '',
      desktopNotification: true,
      source: '1',
      group: false,
      video: true,
      voice: true,
      notificationIconLink: 'https://www.applozic.com/favicon.ico',
      authenticationTypeId: 1,
      accessToken: '',
      locShare: false,
      // googleApiKey: "AIzaSyDKfWHzu9X7Z2hByeW4RRFJrD9SizOzZt4",
      googleApiKey: 'AIzaSyBCkHJdW4ChFLJ8cqJghc-LlhVU_FAl5G0',
      googleMapScriptLoaded: true,
      // mapStaticAPIkey: "AIzaSyCWRScTDtbt8tlXDr6hiceCsU83aS2UuZw",
      autoTypeSearchEnabled: true,
      loadOwnContacts: true,
      olStatus: true,
      onInit: response => {
        if (response === 'success') {
          // calling function load contacts
          // const contactsJSON = self.$store.getters.fetchUsers
          //   .filter(val => val.id !== self.user.id)
          //   .map(user => {
          //     return {
          //       userId: user.id,
          //       displayName: `${user.firstname} ${user.lastname}`,
          //       imageLink:
          //         user.avatar.indexOf("http") < 0
          //           ? `${window.location.protocol}//${window.location.host}${
          //               user.avatar
          //             }`
          //           : user.avatar
          //     };
          //   });
          // self.contacts = contactsJSON;
          // $applozic.fn.applozic("loadContacts", { contacts: contactsJSON });
          // var startNew = document.getElementById('mck-msg-new')
          // startNew.addEventListener("mousemove", () => {
          //   $applozic.fn.applozic("loadContacts", { contacts: self.contacts });
          // });
          var closeButton = document.querySelector('.mck-box-close.mck-close-sidebox')
          closeButton.addEventListener('click', () => {
            window.$('html').removeClass('sidebox-open')
          })
          var chatTotalUnreadCountIntervalId = setInterval(
            function () {
              window.$applozic.fn.applozic('getUserDetail', {
                callback: function (response) {
                  if (response.status === 'success') {
                    self.unread = response.data.totalUnreadCount
                  }
                }
              })
            },
            3000
          )
          window.localStorage.setItem('chatTotalUnreadCountId', chatTotalUnreadCountIntervalId)
          this.setDefaultContacts()
          // watch for back icon click
          const backIconNodes = document.querySelectorAll('.mck-tab-link a.mck-conversation-tab-link')
          for (var node of backIconNodes) {
            node.addEventListener('click', () => {
              self.setDefaultContacts()
            })
          }
        } else {
          // error in user login/register (you can hide chat button or refresh page)
        }
      },
      onTabClicked: response => {},
      contactDisplayName (userId) {
        const users = self.$store.getters.fetchUsers
        const contactUser = users.find((user) => user.uid === userId)
        if (contactUser) {
          return `${contactUser.firstname} ${contactUser.lastname}`
        }
      },
      contactDisplayImage (userId) {
        const users = self.$store.getters.fetchUsers
        const contactUser = users.find((user) => user.uid === userId)
        if (contactUser) {
          return contactUser.avatar.indexOf('http') < 0 ? `${window.location.protocol}//${window.location.host}${contactUser.avatar}` : contactUser.avatar
        }
      }
    })
  }
}
</script>
<style>
.sidebox-open {
  overflow: hidden !important;
}
.chatbutton {
  width: 66px;
  height: 66px;
}
#mck-contact-search-list {
  display: none !important;
}
.mck-box input {
  line-height: inherit !important;
}
.mck-box input::placeholder {
  line-height: inherit !important;
}
.mck-sidebox.fade.in {
  width: 100% !important;
}
.mck-alpha-contact-image img {
  width: 43px !important;
  height: 43px !important;
}
.row.mck-vid-overlay-footer.mck-flex-footer {
  margin: 0 !important;
}
.mck-vid-scr-controls {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.row.mck-vid-overlay-header {
  padding-top: 20px !important;
}
.mck-vid-icon span {
  color: #fff !important;
}
.mck-videocall-image {
  width: 50px !important;
  height: 50px !important;
  border-radius: 100% !important;
}
.footer-controls {
  width: auto !important;
  float: none !important;
  margin: 0 !important;
}
.mck-contact-list .blk-lg-8 {
  width: calc(100% - 55px) !important;
}
.mck-running-on.vis {
  display: none !important;
}
.mck-msg-box {
  min-height: 0px !important;
  font-size: 15px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 16px 14px 10px 14px !important;
}
.applozic-vid-container {
  width: 100% !important;
  padding: 0px !important;
  max-width: none !important;
}
#mck-sidebox-launcher {
  display: none !important;
}
.mck-sidebox-launcher {
  display: none !important;
}
#mck-vid-icon {
  color: #fff !important;
  position: relative;
}
#mck-vid-icon span {
  width: 150px;
  display: block;
  position: absolute;
  left: -43px;
}
.mck-vid-overlay-footer {
  margin-left: 0px !important;
}

.mck-vid-scr-controls .footer-controls {
  display: flex !important;
}
.mck-vid-scr-controls .footer-controls button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 4px !important;
}
#mck-microfone-mute-btn {
  border-radius: 50%;
  height: 56px !important;
  width: 56px !important;
}

.unread {
  position: absolute !important;
  z-index: 99999 !important;
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  background: red !important;
  top: 0px !important;
  right: 0px !important;
  height: 20px !important;
  width: 20px !important;
  border-radius: 50% !important;
  -webkit-transform: rotate(0deg) !important;
  transform: rotate(0deg) !important;
  opacity: 1 !important;
  left: auto !important;
}
</style>





// WEBPACK FOOTER //
// sideboxChat.vue?50698508